import moment from "moment";

export const cutString = (value, max) => {
  return value?.length > max ? value.slice(0, max - 3) + "..." : value;
};

export default {
  install: (app) => {
    app.config.globalProperties.$filters = {
      utcDateToTime(value) {
        return moment(value).format("HH:mm A");
      },

      utcDateToDate(value) {
        return moment(value).format("D MMM");
      },

      utcDateToDateTime(value) {
        return moment(value).format("D MMM HH:mm");
      },

      utcDateToFormattedDateTime(value) {
        if (moment(value).isSame(moment(), "day")) {
          return "Today, " + moment(value).format("HH:mm A");
        }
        if (moment(value).isSame(moment().subtract(1, "day"), "day")) {
          return "Yesterday, " + moment(value).format("HH:mm A");
        }
        if (moment(value).isSame(moment(), "year")) {
          return moment(value).format("D MMM, HH:mm");
        }
        return moment(value).format("D MMM y, HH:mm");
      },
      cutString,
    };
  },
};
